import axios from "../../utils/axios";

async function fetchList(params) {
  return await axios.get(`/single/orders`, { params });
}

async function fetchHistory(params) {
  return await axios.get(`single/orders`, {
    params: { view: "history", ...params },
  });
}

async function fetchOverview(params) {
  return await axios.get(`single/orders/overview`, { params });
}

async function fetch(id) {
  return await axios.get(`/orders/${id}`);
}

async function create(data) {
  return await axios.post(`single/orders`, data);
}

async function updateStatus(id, data) {
  return await axios.patch(`/orders/${id}/status`, data);
}

async function fetchStats() {
  return await axios.get(`single/orders/stats`);
}

async function createBilling(data) {
  return await axios.post(`single/orders/billing`, data);
}

async function addPayments(id, payments) {
  return await axios.post(`single/orders/${id}/payments`, { payments });
}

async function cancelOrder(id, body) {
  return await axios.post(`single/orders/${id}/cancel`, body);
}

async function cancelOrderItems(id, body) {
  return await axios.post(`single/orders/${id}/cancel-items`, body);
}

async function lookupCustomer(phone) {
  return await axios.get("single/pos-customers/lookup", { params: { phone } });
}

// POS: void a whole open table / car bill ({ reason, made })
async function voidOpenBill(orderId, data) {
  return await axios.post(`single/orders/${orderId}/void-open-bill`, data);
}

async function fetchOfflineCustomers(since) {
  return await axios.get("single/pos-customers/offline", {
    params: since ? { since } : {},
  });
}

async function searchCustomers(name) {
  return await axios.get("single/pos-customers/search", { params: { name } });
}

async function rememberCustomer({ name, phone }) {
  return await axios.post("single/pos-customers/remember", {
    name,
    phone_number: phone,
  });
}

async function fetchCustomerReport(params) {
  return await axios.get("single/pos-customers/report", { params });
}

async function fetchCustomerStatement(params) {
  return await axios.get("single/pos-customers/statement", { params });
}

async function fetchActiveCarOrders() {
  return await axios.get("single/orders/car-orders/active");
}

async function addItemsToCarOrder({ order_id, products }) {
  return await axios.patch("single/orders/car-order/add-items", {
    order_id,
    products,
  });
}

async function updateCarOrderItem({
  order_id,
  index,
  product_id,
  qty,
  ...rest
}) {
  return await axios.patch("single/orders/car-order/update-item", {
    order_id,
    index,
    product_id,
    qty,
    ...rest,
  });
}

async function updateCarOrderCar({ order_id, car_number }) {
  return await axios.patch("single/orders/car-order/update-car", {
    order_id,
    car_number,
  });
}

async function removeCarOrderItem({ order_id, product_id }) {
  return await axios.patch("single/orders/car-order/remove-item", {
    order_id,
    product_id,
  });
}

const orderService = {
  fetchList,
  fetchHistory,
  fetchOverview,
  fetch,
  updateStatus,
  fetchStats,
  create,
  createBilling,
  addPayments,
  cancelOrder,
  cancelOrderItems,
  lookupCustomer,
  searchCustomers,
  fetchOfflineCustomers,
  voidOpenBill,
  rememberCustomer,
  fetchCustomerReport,
  fetchCustomerStatement,
  fetchActiveCarOrders,
  addItemsToCarOrder,
  updateCarOrderItem,
  removeCarOrderItem,
  updateCarOrderCar,
};
export default orderService;
